if (!customElements.get('vyv-attributes')) customElements.define('vyv-attributes', class extends HTMLElement {
 connectedCallback() {
  if (this.controller) return;
  this.controller = new AbortController();
  const signal = this.controller.signal;
  const button = this.querySelector('[data-attribute-pause]');
  const viewport = this.querySelector('.vyv-attributes__viewport');
  const track = this.querySelector('.vyv-attributes__track');
  const original = track.firstElementChild;
  const clone = original.cloneNode(true);
  clone.dataset.duplicate = '';
  clone.setAttribute('aria-hidden','true');
  clone.removeAttribute('aria-label');
  track.append(clone);
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const updateMode = () => {
   this.classList.toggle('is-moving', !reduced.matches);
   button.hidden = reduced.matches;
  };
  const resize = () => {
   this.style.setProperty('--attribute-width',`${viewport.clientWidth}px`);
   const pixelsPerSecond = matchMedia('(max-width:767px)').matches ? 34 : 43;
   this.style.setProperty('--attribute-duration',`${original.getBoundingClientRect().width / pixelsPerSecond}s`);
  };
  button.addEventListener('click', () => {
   const paused = this.classList.toggle('is-paused');
   button.setAttribute('aria-label', paused ? 'Resume scrolling attributes' : 'Pause scrolling attributes');
   button.querySelector('[data-pause]').hidden = paused;
   button.querySelector('[data-play]').hidden = !paused;
  }, {signal});
  reduced.addEventListener('change', updateMode, {signal});
  document.addEventListener('visibilitychange', () => {
   this.classList.toggle('is-visible', this.inView && !document.hidden);
  }, {signal});
  this.resizeObserver = new ResizeObserver(resize);
  this.resizeObserver.observe(viewport);
  this.resizeObserver.observe(original);
  this.observer = new IntersectionObserver(entries => {
   this.inView = entries[0].isIntersecting;
   this.classList.toggle('is-visible', this.inView && !document.hidden);
  });
  this.observer.observe(this);
  updateMode(); resize();
  document.fonts.ready.then(() => { if (!signal.aborted) resize(); });
 }
 disconnectedCallback() {
  this.controller?.abort(); this.controller = null;
  this.observer?.disconnect(); this.resizeObserver?.disconnect();
  this.querySelector('[data-duplicate]')?.remove();
 }
});
